import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { RootState } from "../config/Store";
import { AnyAction } from "redux";

interface ReduxData {
  type: string;
  value: any;
}

export const setDataInRedux = (data: ReduxData): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (
    dispatch: ThunkDispatch<RootState, unknown, AnyAction>
  ): Promise<void> => {
    dispatch({
      type: data.type,
      payload: data.value
    });
  };

export const IS_USER_LOGIN = "IS_USER_LOGIN";
export const TOKEN = "TOKEN";
export const CITY_ID = "CITY_ID";
export const EVENT_PRICES = "EVENT_PRICES";